const options = {
  5: "bg-neutral-300/5",
  10: "bg-neutral-300/10",
  25: "bg-neutral-300/25",
  50: "bg-neutral-300/50",
  75: "bg-neutral-300/75",
  90: "bg-neutral-300/90",
  100: "bg-neutral-300",
};

const from = {
  5: "from-neutral-300/5",
  10: "from-neutral-300/10",
  25: "from-neutral-300/25",
  50: "from-neutral-300/50",
  75: "from-neutral-300/75",
  90: "from-neutral-300/90",
  100: "from-neutral-300",
};

export default function getBackgroundNeutral300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
